module.exports = __webpack_public_path__ + "media/images/landing/how_we_do_it-cb4e37333631d205a69f8f1a94dbb237.png";